import React from "react";
import styled from "styled-components";
import ClockIcon from "../../assets/img/icons/clock.svg";
import StopwatchIcon from "../../assets/img/icons/stopwatch.svg";

const DurationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px 5px 10px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 12px;
  width: max-content;
  background-color: ${({ type }) => {
    if (type === "clock") return "#F0FDF4";
    if (type === "stopwatch") return "#FFF7ED";
    return "#F0FDF4";
  }};
  color: ${({ type }) => {
    if (type === "clock") return "#15803D";
    if (type === "stopwatch") return "#C2410C";
    return "#15803D";
  }};
`;

const DurationIcon = styled.div`
  width: 14px;
  height: 14px;
  background-image: url(${({ type }) => {
    if (type === "clock") return ClockIcon;
    if (type === "stopwatch") return StopwatchIcon;
    return ClockIcon;
  }});
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TaskDuration = ({ type = "clock", text }) => {
  if (!text) {
    return <DurationContainer type={type}>-</DurationContainer>;
  }

  return (
    <DurationContainer type={type}>
      <DurationIcon type={type} />
      {text}
    </DurationContainer>
  );
};

export default TaskDuration;
